module.exports = __webpack_public_path__ + "img/rc-ur3.6307c3b5.jpg";